import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'https://vidi3d.com',
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.vidi3d.com',
  contactEmail: process.env.REACT_APP_CONTACT_EMAIL || 'contact@vidi3d.com',
};

export default config;
